import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestReporte } from '../clases/request-reporte';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
  })
  export class MaestrosService {
  
    constructor(private _http: HttpClient) { }
  
    requestTipoServicio(IdCliente: any) {
        const url = environment.URL_BASE + "tiposervicioAuthorization/all?id="+ IdCliente;
        return this._http.get(url);
    }

    requestEstadoServicio() {
        const url = environment.URL_BASE + "estadoservicioAuthorization/all";
        return this._http.get(url);
    }

    requestEstadoAllServicio() {
        const url = environment.URL_BASE + "estadoservicioAuthorization/allEstado";
        return this._http.get(url);
    }


  
}
  